"use client";
import React from "react";
export default function IconSvg(param) {
    var url = param.url, keyword = param.keyword, className = param.className;
    return /*#__PURE__*/ React.createElement("img", {
        height: "36",
        src: "".concat(url),
        alt: "".concat(keyword),
        loading: "lazy",
        className: className
    });
}
